import {
    CLEAR_P24_RESTAURANT_MERCHANT,
    FETCH_P24_RESTAURANT_MERCHANT,
    ADD_P24_RESTAURANT_MERCHANT,
    ATTACH_P24_RESTAURANT_MERCHANT,
    DETACH_P24_RESTAURANT_MERCHANT
} from "../actions/actionTypes";

const defaultState = {
    //merchant wybranej restauracji
    p24RestaurantMerchant: {}
};

export default function p24RestaurantMerchantReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_P24_RESTAURANT_MERCHANT: {
            return {
                ...state,
                p24RestaurantMerchant: action.payload
            };
        }
        case CLEAR_P24_RESTAURANT_MERCHANT: {
            return {
                ...state,
                p24RestaurantMerchant: {}
            };
        }
        case ADD_P24_RESTAURANT_MERCHANT: {
            return {
                ...state,
                p24RestaurantMerchant: action.payload
            };
        }
        case ATTACH_P24_RESTAURANT_MERCHANT: {
            return {
                ...state,
                p24RestaurantMerchant: action.payload
            };
        }
        case DETACH_P24_RESTAURANT_MERCHANT: {
            return {
                ...state,
                p24RestaurantMerchant: {}
            };
        }
        default:
            return state;
    }
}